import React, { useState, useEffect } from 'react';
import RefundRequestForm from './RefundRequestForm';
import './RefundPolicyPage.css';

const RefundPolicyPage = () => {
  const [currentSection, setCurrentSection] = useState('intro');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    { id: 'intro', title: 'Introducción', icon: 'fas fa-info-circle' },
    { id: 'paso1', title: 'Paso 1: Información', icon: 'fas fa-list' },
    { id: 'paso2', title: 'Paso 2: Productos', icon: 'fas fa-box-open' },
    { id: 'paso3', title: 'Paso 3: Resolución', icon: 'fas fa-exchange-alt' },
    { id: 'aspectos', title: 'Aspectos importantes', icon: 'fas fa-check-circle' },
    { id: 'contacto', title: 'Solicitud en línea', icon: 'fas fa-file-alt' }
  ];

  const renderSectionContent = (sectionId) => {
    switch (sectionId) {
      case 'intro':
        return (
          <div className="refund-section-content">
            <div className="refund-highlight">
              <p><strong>¡TRANQUI!</strong> Queremos que compres con confianza. Esta política aplica a compras en la <strong>tienda Javiland</strong>: productos naturales, bienestar y combos de nuestro catálogo actual.</p>
              <p><strong>Plazo:</strong> tienes hasta <strong>30 días</strong> desde que recibes el pedido para solicitar devolución, cambio o garantía, siempre que se cumplan las condiciones de esta página.</p>
              <p><strong>Productos de bienestar y consumo:</strong> por higiene y regulación del sector, solo aceptamos devoluciones de productos <strong>sin abrir</strong>, con <strong>empaque original sellado</strong> e intacto, salvo cuando reportas un defecto de calidad o daño en el transporte (en esos casos te indicaremos cómo documentarlo).</p>
              <p><strong>Costos de envío:</strong> si el motivo es producto incorrecto, defecto de calidad o daño en transporte, Javiland asume los costos de la gestión una vez aprobada. En solicitudes que no califiquen, el cliente puede asumir el envío de retorno.</p>
              <p>Esta política está alineada con estándares del mercado saludable en Colombia (plazo de 30 días, producto sin uso y comprobante de compra). Para novedades, revisa <a href="/noticias">Noticias Javiland</a>.</p>
            </div>
          </div>
        );

      case 'paso1':
        return (
          <div className="refund-section-content">
            <h3>Paso 1: Datos de tu solicitud</h3>
            <p>Usa el <strong>formulario al final de esta página</strong> o, si prefieres, envía la misma información a <strong>support@javiland.com</strong> con asunto «Devolución — [tu número de pedido]».</p>
            <p>Necesitamos:</p>
            <ul>
              <li>Número de pedido Javiland</li>
              <li>Nombre completo del titular</li>
              <li>Correo y celular de contacto</li>
              <li>Ciudad</li>
              <li><strong>Motivo</strong> (elige el que aplique):
                <ul>
                  <li><strong>Producto incorrecto:</strong> llegó algo distinto a lo que pediste.</li>
                  <li><strong>Defecto de calidad:</strong> producto dañado, alterado o que no cumple lo esperado.</li>
                  <li><strong>Daño en transporte:</strong> el empaque o contenido llegó afectado por el envío.</li>
                  <li><strong>Vencimiento:</strong> fecha de vencimiento vencida o demasiado próxima respecto a lo informado en tienda.</li>
                </ul>
              </li>
            </ul>
            <p><strong>No cubre:</strong> cambio de opinión después de abrir o consumir el producto; productos sin empaque original; daños por mal almacenamiento en el hogar.</p>
          </div>
        );

      case 'paso2':
        return (
          <div className="refund-section-content">
            <h3>Paso 2: ¿Qué productos reportas?</h3>
            <p>Indica con claridad cada ítem:</p>
            <ul>
              <li>Nombre del producto (como aparece en tu pedido)</li>
              <li>Presentación (ej. 250 g, 500 ml)</li>
              <li>Cantidad</li>
              <li>Lote o fecha de vencimiento visible en el empaque (si aplica)</li>
            </ul>
            <p><strong>Si es defecto de calidad o daño en transporte:</strong> describe lo ocurrido y ten listas fotos claras del producto y del empaque. Te pediremos las imágenes por correo si hace falta.</p>
          </div>
        );

      case 'paso3':
        return (
          <div className="refund-section-content">
            <h3>Paso 3: ¿Cómo quieres resolverlo?</h3>
            <ul>
              <li><strong>Reembolso:</strong> devolvemos el valor del producto afectado por el mismo medio de pago (Wompi / tarjeta u otro método usado en checkout), una vez recibamos y validemos el producto cuando aplique retorno físico.</li>
              <li><strong>Reemplazo:</strong> enviamos el mismo producto sin costo adicional para ti, si hay disponibilidad en catálogo.</li>
            </ul>
            <p>Si el valor del reemplazo difiere por cambio de referencia, te contactaremos antes de proceder.</p>
          </div>
        );

      case 'aspectos':
        return (
          <div className="refund-section-content">
            <h3>Aspectos que debes tener en cuenta</h3>
            <ul>
              <li>El producto debe estar <strong>sin usar</strong> y, salvo defecto reportado, <strong>con sellos y empaque originales</strong>.</li>
              <li>Conserva tu comprobante de compra (correo de confirmación o número de pedido).</li>
              <li>El proceso completo suele tomar <strong>8 a 15 días hábiles</strong> desde que aprobamos tu caso.</li>
              <li>Plazo máximo para iniciar solicitud: <strong>30 días</strong> desde la entrega.</li>
              <li>Te daremos instrucciones de envío solo cuando tu solicitud sea aprobada.</li>
              <li>Pedidos con valor superior a <strong>$300.000 COP</strong>: usa transportadora con seguimiento o seguro.</li>
              <li>Artículos en promoción especial pueden tener condiciones distintas; te lo indicaremos al revisar el pedido.</li>
            </ul>
          </div>
        );

      case 'contacto':
        return (
          <div className="refund-section-content">
            <h3>Solicitud en línea</h3>
            <p>Canal oficial para devoluciones, cambios y garantías de la tienda. Guardamos tu caso en nuestro sistema y te respondemos por correo.</p>
            <RefundRequestForm />
            <p className="refund-contact-alt">
              <strong>Horario de atención:</strong> lunes a viernes, 9:00 a 18:00 (hora Colombia).<br />
              <strong>Correo alterno:</strong> support@javiland.com
            </p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="refund-page">
      <div className="refund-container">
        <div className="refund-header">
          <button
            className="back-button"
            onClick={() => {
              window.history.pushState({}, '', '/');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Volver al Inicio
          </button>
          <div className="refund-logo">
            <img src="/images/Logo_Javiland_Largo.png" alt="Javiland" />
          </div>
          <h1>Política de Devoluciones</h1>
          <p className="refund-subtitle">Última actualización: Mayo 2026</p>
        </div>

        <div className="refund-body">
          <div className="refund-sidebar">
            <nav className="refund-navigation">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`refund-nav-item ${currentSection === section.id ? 'active' : ''}`}
                  onClick={() => setCurrentSection(section.id)}
                >
                  <i className={section.icon}></i>
                  <span>{section.title}</span>
                </button>
              ))}
            </nav>
          </div>

          <div className="refund-content">
            <div className="refund-scrollable">
              {renderSectionContent(currentSection)}

              <div className="refund-footer">
                <h4>Nota importante</h4>
                <p>Esta Política de Devoluciones es parte integral de nuestros Términos y Condiciones. Al realizar una compra, usted acepta esta política.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
